<template>
    <div class="premium-partner">
        <section class="section page-wrapper">
            <div class="section__content">
                <h1>{{ $t('pages.our_partners.ferrycenter_heading') }}</h1>
                <p>{{ $t('pages.our_partners.ferrycenter_premium_partner') }}</p>
                <div class="premium-partner__divider" />

                <div class="premium-partner__section">
                    <h3>{{ $t('pages.our_partners.ferrycenter_section1_title') }}</h3>
                    <p>{{ $t('pages.our_partners.ferrycenter_section1_text') }}</p>
                </div>
                <div class="premium-partner__section">
                    <h3>{{ $t('pages.our_partners.ferrycenter_section2_title') }}</h3>
                    <p>{{ $t('pages.our_partners.ferrycenter_section2_text1') }}</p>
                    <p>{{ $t('pages.our_partners.ferrycenter_section2_text2') }}</p>
                </div>
                <div class="premium-partner__section">
                    <h3>{{ $t('pages.our_partners.ferrycenter_section3_title') }}</h3>
                    <ol>
                        <li v-for="n in 5" :key="n">
                            <svg-icon name="check_circle" />
                            <span>{{ $t(`pages.our_partners.ferrycenter_section3_item${n}`) }}</span>
                        </li>
                    </ol>
                </div>
                <div class="premium-partner__section">
                    <h3>{{ $t('pages.our_partners.ferrycenter_section4_title') }}</h3>
                    <ol>
                        <li v-for="n in 7" :key="n">
                            <svg-icon name="check_circle" />
                            <span>{{ $t(`pages.our_partners.ferrycenter_section4_item${n}`) }}</span>
                        </li>
                    </ol>
                    <p>
                        <strong>{{ $t('pages.our_partners.ferrycenter_section4_promo') }}</strong>
                        <strong>{{ $t('pages.our_partners.ferrycenter_section4_promo_code') }}</strong>
                    </p>
                    <p>{{ $t('pages.our_partners.ferrycenter_section4_code_duration') }}</p>
                </div>

                <div class="premium-partner__divider" />

                <div class="premium-partner__actions">
                    <a
                        class="button button--primary"
                        :href="$t('pages.our_partners.ferrycenter_site_link')"
                        target="_blank"
                    >
                        {{ $t('pages.our_partners.ferrycenter_cta') }}
                    </a>
                </div>
            </div>

            <Contact />
        </section>
    </div>
</template>

<script>
import Contact from '~/components/sections/Contact';
export default {
    name: 'Ferrycenter',
    components: { Contact },
    asyncData({ app, redirect }) {
        if (!['en', 'ch', 'fr'].includes(app.i18n.locale)) {
            redirect(app.localePath({ name: 'index' }));
        }
    },
    head() {
        return {
            title: this.$t('pages.our_partners.ferrycenter_meta_title'),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$t('pages.our_partners.ferrycenter_seo_description'),
                },
            ],
        };
    },
    nuxtI18n: {
        paths: {
            ch: '/unsere-partner/ferrycenter',
            fr: '/nos-partenaires/ferrycenter',
            en: '/our-partners/ferrycenter',
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/blocks/_premium-partner.scss';
</style>
